const ClosureNotice: React.FC = () => {
    return (
        <div className="bg-red-100 border-l-4 border-red-600 p-6 mb-8">
            <div className="max-w-4xl mx-auto">
                <h2 className="font-bold text-lg text-red-800 mb-2">
                    ⚠️ BELANGRIJK BERICHT
                </h2>
                <p className="text-red-800 text-base font-semibold mb-2">
                    Bar Elvire sluit definitief aan het einde van juni.
                </p>
                <p className="text-red-700 text-sm">
                    Dank je wel voor de 2 jaren van steun en gezelligheid. We kijken terug op mooie herinneringen met onze klanten en gasten.
                </p>
            </div>
        </div>
    );
};

export default ClosureNotice;
